
<script>
    import Vue from 'vue';

    export default {

        getNearestPharmacies (lat, lng, limit = 10, deliveryOnly = false, memberOnly = false, doesVaccines = 0) {
            var url = `/api/public/nearest-pharmacies?latitude=${lat}&longitude=${lng}`;

            var config = {
                headers: {
                    'X-Origin-Platform': 'ANY',
                }
            }

            if (deliveryOnly || memberOnly) {
                url = `${url}&limit=30`;
            } else {
                url = `${url}&limit=${limit}`;
            }

            if (memberOnly) {
                url = `${url}&member=true`;
            } else {
                url = `${url}&member=false`;
            }

            if (doesVaccines == 1) {
                url = `${url}&doesVaccines=1`;
            }

            return Vue.axios.get(url, config)
                .then(response => {return response.data;});
        },

        getAppointments(page = 0, size = 320) {
          const url = `/api/public/appointments?page=${page}&size=${size}&device=web&sort=datetime,asc`;
          return Vue.axios.get(url)
              .then(response => ({
                success: true,
                data: response.data.content,
              }))
              .catch(error => {
                if (error.response) {
                  // The request was made and the server responded with a status code that falls out of the range of 2xx
                  console.debug(error.response);
                  return {
                    success: false,
                    status: error.response.status,
                    message: error.response.message,
                  }
                } else if (error.request) {
                  // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
                  console.debug('error.request ', error.request);
                  return {
                    success: false,
                    message: 'Did not receive a response from the server.',
                  }
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.debug('error', error.request);
                  return {
                    success: false,
                    message: 'Failed to make the request.',
                  }
                }
              });
        },

        getCoupon(couponId) {
          const url = `/api/public/coupon/${encodeURIComponent(couponId)}`;
          const config = {
            headers: {
              'X-Origin-Platform': 'ANY',
            }
          };
          return Vue.axios.get(url, config)
              .then(response => ({
                success: true,
                data: response.data,
              }))
              .catch(error => ({
                success: false,
                message: (error.response && error.response.data && error.response.data.message)
                  ? error.response.data.message
                  : 'Invalid coupon',
              }));
        },

        lookupPostcode(partial) {
          const searchTerm = partial.trim();
          
          if (!searchTerm) {
            return Promise.resolve([]);
          }
          
          return fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(searchTerm)}/autocomplete`)
            .then(response => response.json())
            .then(data => {
              if (data && data.result) {
                return data.result;
              }
              return [];
            })
            .catch(error => {
              console.error('API Error:', error);
              return [];
            });
        },
        
        /** Raw getAddress.io lines with blank parts kept, for splitting into address fields. */
        getRawAddressesByPostcode(postcode) {
          const cleanPostcode = String(postcode || '').replace(/\s/g, '');
          return Vue.axios.get(`/api/public/get-address?postcode=${encodeURIComponent(cleanPostcode)}`, {
            headers: { 'X-Origin-Platform': 'ANY' }
          }).then(response => (response.data && Array.isArray(response.data.addresses) ? response.data.addresses : []));
        },

        getAddressesByPostcode(postcode) {
          const cleanPostcode = postcode.replace(/\s/g, '');
          const url = `/api/public/get-address?postcode=${encodeURIComponent(cleanPostcode)}`;
          
          const config = {
            headers: {
              'X-Origin-Platform': 'ANY',
            }
          };
          
          return Vue.axios.get(url, config)
            .then(response => {
              if (response.data && response.data.addresses) {
                return response.data.addresses.map(address => {
                  if (typeof address === 'string') {
                    const parts = address.split(',')
                      .map(part => part.trim())
                      .filter(part => part && part !== '');
                    return parts.join(', ');
                  }
                  return address;
                });
              }
              return [];
            })
            .catch(error => {
              console.error('Error fetching addresses:', error);
              return [];
            });
        },
    }
</script>
